<template>
  <b-modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="$t('Configurar marketcenter')"
    size="lg"
    ok-variant="warning"
    ok-only
    no-close-on-esc
    no-close-on-backdrop
    centered
    no-footer
  >
    <form-render
      :form.sync="formConfig"
      :fields="fieldsConfig"
      @send="onAccept"
      ref="formRenderMarketcenter"
    >
    </form-render>
    <template #modal-footer>
      <b-button variant="danger" v-show="isMeli && isAdmin" @click.prevent="removeIntegration()" :disabled="loading.remove || loading.configMarketcenter">
        <b-spinner v-show="loading.remove" small></b-spinner>
        {{$t('Habilitar redirección')}}
      </b-button>
      <b-button variant="warning" @click.prevent="ok()" :disabled="loading.configMarketcenter || loading.remove">
        <b-spinner v-show="loading.configMarketcenter" small></b-spinner>
        {{$t('Guardar configuración')}}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    fieldsConfig: { type: Array },
    formConfig: { type: Object },
    isMeli: { type: Boolean }
  },
  data() {
    return {
      loading: {
        remove: false,
        configMarketcenter:false
      }
    }
  },
  computed: {
    ...mapGetters({
      generalLoading: 'getLoading'
    }),
    isAdmin () {
      return ['admin', 'superadmin'].includes(this.$session.get('cas_user').role)
    }
  },
  watch: {
    generalLoading: {
      handler () {
        this.loading.remove = !!this.generalLoading.deleteIntegrationMkc
        this.loading.configMarketcenter = !!this.generalLoading.postConfigMarketcenter
      },
      deep: true
    }
  },
  methods : {
    ok (e) {
      this.$refs.formRenderMarketcenter.checkForm()
    },
    onAccept(data) {
      this.$emit('postConfigFields', data)
    },
    removeIntegration() {
      this.$emit('deleteIntegration')
    }
  }
}
</script>

